"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buildCollableOpenUrl = (args) => ({ entryVars: { url, }, processor, }) => {
    if (typeof url !== 'string') {
        processor.root.alert('Error', 'The url to open should be an string');
        return;
    }
    args.openOnPlatform(url)
        .catch(() => processor.root.alert('Error', 'The supplied url can\'t be open'));
};
exports.default = buildCollableOpenUrl;
